import { onSlotRendered } from './modules/monetization';
import MonetizationManager from './modules/monetization/monetization-manager';
import PrebidAdapter from './modules/monetization/prebid-adapter';
import AmazonAdapter from './modules/monetization/amazon-adapter';
import AdSlot from './modules/monetization/ad-slot';
import SharedConfig from './modules/monetization/shared-config';
import { getResponsiveSizes, sizes } from './modules/monetization/config';
import { getPolicyViolatedWords } from './modules/monetization/get-policy-violated-words';
import { hasDiageoViolatedWords } from './modules/monetization/has-diageo-violated-words.js';
import { filterBiddersByGeo } from './modules/monetization/filter-bidders-by-geo';
import { getGeolocation } from './services/get-geolocation';
import { initIntentIq } from './modules/intent-iq';
import { associateArray } from './services/associate-array';
import { getNestedText } from './services/article/get-nested-text.js';

const $anchorAdvCloseButton = document.querySelector(`.js-adv-close-btn`);
const $fullArticleContent = document.querySelector(`.js-article`);

if ($anchorAdvCloseButton) {
  $anchorAdvCloseButton.addEventListener(`click`, (event) => {
    event.target.parentNode.classList.toggle(`c-adv-anchor--collapsed`);
  });
}

const gptAdSlotConfigs = associateArray(window.Site.slots || [], `code`);
const prebidAdSlotConfigs = associateArray(window.Site.prebidUnits || [], `code`);
const targeting = window.Site.targeting || {};
const responsiveSizes = getResponsiveSizes(sizes);

if ($fullArticleContent) {
  const contentText = getNestedText($fullArticleContent);

  targeting.violated_words = getPolicyViolatedWords(contentText);
  targeting.has_diageo_words = hasDiageoViolatedWords(contentText);
}

export const monetizationManager = new MonetizationManager([
  // Anchor
  `brieflyrsa_universal_anchor`,
  `legit_anchor`,
  `kami_universal_anchor`,
  `tuko_universal_anchor`,

  // Sidebar sticky
  `legit_sidebar_bottom`,
  `tuko_09`,
  `briefly_05`,
  `kami_08`,

  // For All Yen project
  `yen`,

  // Profit Button on Briefly
  `briefly_1x1_pixel`,
]);

getGeolocation().then((geo) => {
  window.adSharedConfigs = Object.values(gptAdSlotConfigs).map((config) => {
    const filteredPrebidConfigs = filterBiddersByGeo(geo, prebidAdSlotConfigs[config.code]);
    const sharedConfig = new SharedConfig({ ...config }, filteredPrebidConfigs);

    sharedConfig.setResponsiveSizes(responsiveSizes);

    return sharedConfig;
  });

  window.adSharedConfigs = associateArray(window.adSharedConfigs, `sharedId`);

  const uniqueConfigs = Object.values(window.adSharedConfigs).map((sharedConfig) =>
    sharedConfig.getUniqueConfig(),
  );

  const slots = uniqueConfigs.map((config) => new AdSlot(config));

  monetizationManager.targeting = targeting;

  initIntentIq(geo, (intentId, intentTargeting) => {
    if (intentId) {
      monetizationManager.ppid = intentId;
    }

    if (intentTargeting) {
      window.Site.targeting = {
        ...window.Site.targeting,
        ...intentTargeting,
      };

      monetizationManager.targeting = { ...targeting, ...intentTargeting };
    }

    monetizationManager.addAdapter(new PrebidAdapter());
    monetizationManager.addAdapter(new AmazonAdapter(window.Site.apsPubID));
    monetizationManager.onSlotRendered = onSlotRendered;
    monetizationManager.addSlots(slots);

    monetizationManager.enableGPT();
  });
});
